module.exports = __webpack_public_path__ + "static/media/quickbooks-logo.4f472ca3.svg";